import moment from 'moment-timezone'

import { getMomentTimeZone } from '../../service/locale/timezone'
import { PICKUP_TIME_OPTIONS } from './order-form/schedule-form/pickup-time/pickup-time.constants'
import { DROPOFF_TIME_OPTIONS } from './order-form/schedule-form/dropoff-time/dropoff-time.constants'

const currentTimeZone = getMomentTimeZone()

const orderTimeService = {
  getUpdatedPickupDropoffTime: ({ requestAt, dropOffAt }) => {
    const currentTime = moment.tz(currentTimeZone)
    const updatedRequestTime =
      requestAt === PICKUP_TIME_OPTIONS.NOW ? currentTime.format() : requestAt

    let updatedDropoffTime

    switch (dropOffAt) {
      case DROPOFF_TIME_OPTIONS.FASTEST:
        updatedDropoffTime = moment
          .tz(updatedRequestTime, currentTimeZone)
          .add(4, 'h')
          .format()
        break
      case DROPOFF_TIME_OPTIONS.INSTANT_DELIVERY:
        updatedDropoffTime = currentTime.format()
        break
      default:
        updatedDropoffTime = dropOffAt
    }

    return {
      request_at: updatedRequestTime,
      drop_off_at: updatedDropoffTime,
    }
  },
}

export { orderTimeService }
